import {createContext} from 'react';
import {ContractHolder} from '@/repositories/beneva-api/endpoints/documents';
import {Investor, InvestorAccount} from '@/types/client-info';

export interface DocumentCreationActionsContextValue {
  onCreateForNewContractHolder: () => void;
  onCreateForRecentContractHolder: (contractHolder: ContractHolder) => void;
  onCreateForNewAccount: (investor: Investor) => void;
  onCreateForExistingAccount: (investor: Investor, accountNo: InvestorAccount['accountNo']) => void;
}

export const DocumentCreationActionsContext = createContext<DocumentCreationActionsContextValue | null>(null);
